export class ThreeDimensionalSet<T, U, B> {
  parentMap: Map<T, Map<U, Set<B>>> = new Map();

  add(key1: T, key2: U, key3: B) {
    const childMap = this.parentMap.get(key1);
    if (childMap) {
      const grandChildSet = childMap.get(key2);
      if (!grandChildSet) {
        const newSet = new Set<B>();
        newSet.add(key3);
        childMap.set(key2, newSet);
      } else {
        grandChildSet.add(key3);
      }
    } else {
      const newChildMap = new Map();
      const newGrandChildSet = new Set<B>([key3]);
      newGrandChildSet.add(key3);
      newChildMap.set(key2, newGrandChildSet);
      this.parentMap.set(key1, newChildMap);
    }
  }

  has(key1: T, key2: U, key3: B) {
    return Boolean(this.parentMap.get(key1)?.get(key2)?.has(key3));
  }
}
